import * as React from "react"
import { useTheme } from "@mui/material";

const SearchSvgComponent = (props) => {
  const { main } = useTheme().palette.primary;
 return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="#1D5BBF"
      d="M6.892 5.6a.956.956 0 0 0-1.336 0 6.277 6.277 0 0 0-1.847 5.142.939.939 0 0 0 1.034.831.933.933 0 0 0 .846-1.016 4.447 4.447 0 0 1 1.303-3.645.916.916 0 0 0 0-1.312Z"
      style={{
        fill: "#76818E",
       
        fillOpacity: 1,
      }}
    />
    <path
      fill="#64748B"
      d="m24.726 23.408-6.775-6.775a.932.932 0 1 0-1.318 1.318l6.775 6.775a.928.928 0 0 0 1.318 0 .932.932 0 0 0 0-1.318Z"
      style={{
        fillOpacity: 1,
      }}
    />
    <path
      fill="#64748B"
      d="M10.57 0C4.74 0 0 4.741 0 10.57c0 5.828 4.741 10.57 10.57 10.57 5.828 0 10.57-4.742 10.57-10.57C21.14 4.74 16.398 0 10.57 0Zm0 19.29c-4.81 0-8.72-3.912-8.72-8.72 0-4.809 3.91-8.721 8.72-8.721 4.809 0 8.72 3.912 8.72 8.72 0 4.809-3.912 8.72-8.72 8.72v.001Z"
      style={{
        fillOpacity: 1,
      }}
    />
  </svg>
}
export default SearchSvgComponent

